import { Injectable } from '@angular/core';
import { OverlayAccessor } from '../../services/overlay-accessor';

/**
 * a reference to the dialog itself. can be injected into the component added to the
 * overlay and then used to close itself.
 */
@Injectable({
  providedIn: 'root'
})
export class DialogRef extends OverlayAccessor {}
